/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiFlexGroup, EuiPanel, EuiSpacer, EuiTitle } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import { DocLink } from '@modules/doclinks'

import ExternalLink from '@/components/ExternalLink'
import { elasticSupportUrl } from '@/apps/userconsole/urls'

import type { FunctionComponent } from 'react'

type Props = {
  showDoc: boolean
}

const OtherLinks: FunctionComponent<Props> = ({ showDoc }) => (
  <EuiPanel color='transparent' hasBorder={true} paddingSize='l'>
    <EuiTitle size='xs'>
      <h2>
        <FormattedMessage id='help.other-links' defaultMessage='Helpful Links' />
      </h2>
    </EuiTitle>

    <EuiSpacer size='m' />

    <EuiFlexGroup direction='column' gutterSize='s'>
      <DocLink link='gettingStartedDocLink'>
        <FormattedMessage id='help.getting-started' defaultMessage='Getting Started' />
      </DocLink>
      {showDoc && (
        <DocLink link='helpDocLink'>
          <FormattedMessage id='help.docs.title' defaultMessage='Documentation' />
        </DocLink>
      )}
      <DocLink link='faqGettingStarted'>
        <FormattedMessage id='help.faq' defaultMessage='FAQ' />
      </DocLink>
      <DocLink link='keepingYourDeploymentHealthy'>
        <FormattedMessage
          id='help.keep-your-deployment-healthy'
          defaultMessage='Keeping your cluster healthy'
        />
      </DocLink>
      {showDoc ? (
        <ExternalLink
          showExternalLinkIcon={false}
          href='https://www.elastic.co/support/welcome/cloud'
        >
          <FormattedMessage
            id='help.support-policy-standard.title'
            defaultMessage='Support Policy'
          />
        </ExternalLink>
      ) : (
        <ExternalLink
          showExternalLinkIcon={false}
          href='https://www.elastic.co/legal/support_policy/cloud_premium'
        >
          <FormattedMessage
            id='help.support-policy-premium.title'
            defaultMessage='Premium Support Policy'
          />
        </ExternalLink>
      )}
      <ExternalLink showExternalLinkIcon={false} href={elasticSupportUrl}>
        <FormattedMessage id='help.status' defaultMessage='Service Status' />
      </ExternalLink>
    </EuiFlexGroup>
  </EuiPanel>
)

export default OtherLinks
